import React, { useEffect, useState } from 'react';
import { pesos, numKm, enlaceViaje, nombrePropio } from './formato';
// Hora de Mendoza siempre, aunque el telefono o el navegador esten en otra zona
const TZ = 'America/Argentina/Mendoza';

const API_BASE = 'https://cyker.satelitax.com.ar/api';

const TEAL    = '#74C8D2';
const TEXT1   = '#E6EDF3';
const TEXT2   = '#7D8590';
const SURFACE = '#161B22';
const SURFACE2= '#1C2128';
const BORDER  = '#30363D';
const GREEN   = '#22C55E';

const CARD = {
  background: SURFACE,
  border: `1px solid ${BORDER}`,
  borderRadius: '16px',
  marginBottom: '12px',
  overflow: 'hidden',
};

function Historial() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandido, setExpandido] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('Sin token. Cerrá y volvé a abrir desde la app.');
      setLoading(false);
      return;
    }

    const cargar = async () => {
      try {
        const res = await fetch(API_BASE + '/turnos/historial-completo', {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        if (res.status === 401) { setError('Sesión expirada. Cerrá y volvé a abrir.'); return; }
        if (!res.ok) { setError('Error al cargar historial (' + res.status + ').'); return; }
        setData(await res.json());
      } catch (e) {
        setError('Error de conexión.');
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, [token]);

  const formatFechaCorta = (isoStr) => {
    if (!isoStr) return '-';
    try {
      const d = new Date(isoStr);
      const dia = d.toLocaleDateString('es-AR', { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: TZ });
      const hora = d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
      return `${dia} ${hora}`;
    } catch { return isoStr; }
  };

  const formatKm = (metros) => numKm(metros);

  const fmtDuracion = (inicio, fin) => {
    if (!inicio || !fin) return '-';
    const diff = Math.max(0, Math.floor((new Date(fin).getTime() - new Date(inicio).getTime()) / 1000));
    const h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60);
    if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
    return `${m}m`;
  };

  const bgStyle = {
    minHeight: '100vh',
    background: '#0D1117',
    padding: '0 16px 40px',
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    position: 'relative',
  };

  const glowStyle = {
    position: 'fixed', top: 0, left: '50%',
    transform: 'translateX(-50%)',
    width: '600px', height: '280px',
    background: 'radial-gradient(ellipse at top, rgba(116,200,210,0.07) 0%, transparent 70%)',
    pointerEvents: 'none', zIndex: 0,
  };

  const contentStyle = { position: 'relative', zIndex: 1, maxWidth: '400px', margin: '0 auto' };

  // --- Loading ---
  if (loading) return (
    <div style={{ ...bgStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={glowStyle} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
        <div style={{
          width: '36px', height: '36px',
          border: `3px solid ${SURFACE2}`, borderTop: `3px solid ${TEAL}`,
          borderRadius: '50%', animation: 'spin 0.8s linear infinite',
        }} />
        <div style={{ color: TEXT2, marginTop: '16px', fontSize: '14px' }}>Cargando historial...</div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  // --- Error ---
  if (error) return (
    <div style={{ ...bgStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={glowStyle} />
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
        <div style={{
          ...CARD, padding: '24px 28px', marginTop: '8px',
          color: TEXT1, fontSize: '15px', textAlign: 'center', maxWidth: '320px',
        }}>
          <div style={{ fontSize: '36px', marginBottom: '12px' }}>⚠️</div>
          <div style={{ fontWeight: '600', marginBottom: '8px' }}>Error</div>
          <div style={{ color: TEXT2, fontSize: '13px' }}>{error}</div>
        </div>
      </div>
    </div>
  );

  const turnos = data?.turnos || [];
  const vehiculo = data?.vehiculo || {};

  // Totales generales
  let totalRecaudado = 0, totalKm = 0, totalViajes = 0;
  for (const t of turnos) {
    totalRecaudado += (t.totales?.importe_total || 0);
    totalKm += (t.totales?.km_total || 0);
    totalViajes += (t.totales?.cantidad_viajes || 0);
  }

  // --- Sin turnos ---
  if (turnos.length === 0) return (
    <div style={bgStyle}>
      <div style={glowStyle} />
      <div style={contentStyle}>
        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '24px' }}>
          <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
          <div style={{ fontSize: '10px', color: TEXT2, letterSpacing: '4px', textTransform: 'uppercase' }}>Taxímetro Digital</div>
        </div>
        <div style={{ ...CARD, padding: '40px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: TEXT1, marginBottom: '8px' }}>Sin turnos registrados</div>
          <div style={{ fontSize: '13px', color: TEXT2 }}>Los turnos que realices aparecerán acá.</div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={bgStyle}>
      <div style={glowStyle} />
      <div style={contentStyle}>

        {/* Header */}
        <div style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '24px' }}>
          <img src="/logo_cyker_web.png" alt="Cyker" style={{ width: '130px', height: 'auto', display: 'block', margin: '0 auto 10px' }} />
          <div style={{ fontSize: '10px', color: TEXT2, letterSpacing: '4px', textTransform: 'uppercase' }}>Historial de Turnos</div>
          {vehiculo.aditamento && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(116,200,210,0.1)', border: '1px solid rgba(116,200,210,0.25)',
              borderRadius: '20px', padding: '6px 18px', marginTop: '12px',
            }}>
              <span style={{ fontSize: '18px' }}>🚕</span>
              <span style={{ color: TEAL, fontWeight: '700', fontSize: '16px', letterSpacing: '1px' }}>Taxi {vehiculo.aditamento}</span>
            </div>
          )}
        </div>

        {/* Resumen general */}
        <div style={CARD}>
          <div style={{ height: '3px', background: TEAL }} />
          <div style={{ padding: '16px 20px' }}>
            <div style={{ fontSize: '10px', color: TEAL, fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '14px' }}>
              Resumen general
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {[
                { label: 'Turnos', value: String(turnos.length) },
                { label: 'Recaudado', value: pesos(totalRecaudado) },
                { label: 'Viajes', value: String(totalViajes) },
                { label: 'Km Total', value: formatKm(totalKm) },
              ].map(({ label, value }) => (
                <div key={label} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: '800', color: TEXT1, fontVariantNumeric: 'tabular-nums' }}>{value}</div>
                  <div style={{ fontSize: '10px', color: TEAL, textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '2px' }}>{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Lista de turnos */}
        {turnos.map((turno) => {
          const id = turno.id;
          const isExpandido = expandido === id;
          const viajes = turno.viajes || [];
          const chofer = nombrePropio((turno.chofer_nombre || '') + ' ' + (turno.chofer_apellido || '')) || '-';
          const esFinalizado = !!turno.fin;

          return (
            <div key={id} style={{ ...CARD, cursor: 'pointer' }} onClick={() => setExpandido(isExpandido ? null : id)}>
              {/* Card header */}
              <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                {/* Fecha badge */}
                <div style={{
                  minWidth: '44px', textAlign: 'center',
                  background: 'rgba(116,200,210,0.08)', borderRadius: '10px', padding: '8px 6px',
                }}>
                  <div style={{ fontSize: '18px', fontWeight: '800', color: TEXT1, lineHeight: 1 }}>
                    {turno.inicio ? new Date(turno.inicio).toLocaleDateString('es-AR', { day: 'numeric', timeZone: TZ }) : '-'}
                  </div>
                  <div style={{ fontSize: '10px', color: TEAL, textTransform: 'uppercase', marginTop: '2px' }}>
                    {turno.inicio ? new Date(turno.inicio).toLocaleDateString('es-AR', { month: 'short', timeZone: TZ }) : ''}
                  </div>
                </div>

                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ fontSize: '20px', fontWeight: '800', color: TEXT1, fontVariantNumeric: 'tabular-nums' }}>
                      {pesos(turno.totales?.importe_total || 0)}
                    </span>
                    <span style={{
                      fontSize: '10px', fontWeight: '700', letterSpacing: '0.5px',
                      padding: '3px 8px', borderRadius: '8px',
                      background: esFinalizado ? 'rgba(34,197,94,0.12)' : 'rgba(116,200,210,0.12)',
                      color: esFinalizado ? GREEN : TEAL,
                    }}>
                      {esFinalizado ? 'FINALIZADO' : 'ACTIVO'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '4px', fontSize: '12px', color: TEXT2 }}>
                    <span>{turno.totales?.cantidad_viajes || 0} viajes</span>
                    <span>·</span>
                    <span>{esFinalizado ? fmtDuracion(turno.inicio, turno.fin) : 'En curso'}</span>
                    <span>·</span>
                    <span>{formatKm(turno.totales?.km_total)} km</span>
                  </div>
                </div>

                {/* Expand icon */}
                <div style={{ color: TEXT2, fontSize: '12px', transition: 'transform 0.2s', transform: isExpandido ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  ▼
                </div>
              </div>

              {/* Expanded detail */}
              {isExpandido && (
                <div onClick={(e) => e.stopPropagation()} style={{ borderTop: `1px solid ${BORDER}`, padding: '14px 16px' }}>
                  {/* Stats grid */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
                    {[
                      { label: 'Inicio', value: formatFechaCorta(turno.inicio) },
                      { label: 'Fin', value: turno.fin ? formatFechaCorta(turno.fin) : 'En curso' },
                      { label: 'Chofer', value: chofer },
                      { label: 'Eficiencia', value: ((parseFloat(turno.eficiencia) || 0).toFixed(1)).replace('.', ',') + '%' },
                      { label: 'Km Ocupado', value: formatKm((parseFloat(turno.km_ocupado) || 0) * 1000) + ' km' },
                      { label: 'Km Libre', value: formatKm((parseFloat(turno.km_libre) || 0) * 1000) + ' km' },
                    ].map(({ label, value }) => (
                      <div key={label} style={{
                        background: SURFACE2, borderRadius: '10px', padding: '10px 12px',
                        border: `1px solid ${BORDER}`,
                      }}>
                        <div style={{ fontSize: '10px', color: TEAL, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '3px' }}>{label}</div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: TEXT1 }}>{value}</div>
                      </div>
                    ))}
                  </div>

                  {/* Viajes */}
                  {viajes.length > 0 && (
                    <div>
                      <div style={{ fontSize: '10px', color: TEAL, fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '8px' }}>
                        Viajes ({viajes.length})
                      </div>
                      {viajes.map((viaje, idx) => (
                        <a key={viaje.id || idx} href={enlaceViaje(viaje)} style={{
                          display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none', color: 'inherit',
                          padding: '10px 0', borderBottom: idx < viajes.length - 1 ? `1px solid ${BORDER}` : 'none',
                        }}>
                          <span style={{ fontSize: '12px', fontWeight: '800', color: TEAL, minWidth: '28px' }}>#{viajes.length - idx}</span>
                          <span style={{ flex: 1, fontSize: '12px', color: TEXT2 }}>{formatKm(viaje.distancia_metros)} km</span>
                          <span style={{ fontSize: '14px', fontWeight: '700', color: TEXT1, fontVariantNumeric: 'tabular-nums' }}>
                            {pesos(parseFloat(viaje.importe) || 0)}
                          </span>
                          <span style={{ fontSize: '11px', color: TEXT2, minWidth: '70px', textAlign: 'right' }}>
                            {viaje.inicio ? new Date(viaje.inicio).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', timeZone: TZ }) : '-'}
                          </span>
                          <span style={{ color: TEAL, fontSize: '18px', lineHeight: 1 }} aria-hidden="true">›</span>
                        </a>
                      ))}
                    </div>
                  )}

                  {viajes.length === 0 && (
                    <div style={{ fontSize: '13px', color: TEXT2, textAlign: 'center', padding: '10px 0' }}>
                      Sin viajes en este turno
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}

        <div style={{ textAlign: 'center', marginTop: '8px', color: '#3D444D', fontSize: '11px' }}>
          Últimos {turnos.length} turnos · Sistema Cyker
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

export default Historial;
